import BackButton from "../../../../src/components/BackButton";
import * as React from 'react';
export default {
  BackButton,
  React
};